<template> 
  <div>
    <div
      v-if="errorMessage">
      <p class="alert alert-danger">{{ errorMessage }}</p>
      <p class="mb-0"><a href="javascript:void(0)" @click="tryAgain">{{ $t('Tente novamente') }}</a></p>
    </div>
    <div v-if="!errorMessage">
      <div
        v-if="emailVerificationRequired"
        :class="{'box-loading': loading}">
        <form
          id="verification-form"
          v-on:submit.prevent="auth()">
          <div class="form-group">
            <label>Você receberá um código de 6 dígitos no seu e-mail. Por favor, informe-o aqui.</label>
            <input
              v-autofocus
              type="text"
              class="form-control"
              v-model="code">
            <ValidateMessage :error="validateErrors['code']" />
          </div>
        </form>
        <button
          type="submit"
          form="verification-form"
          class="btn btn-primary">
          {{ $t('Save') }}
          </button>
      </div>
      <div
        v-if="!emailVerificationRequired">
        <p>Carregando...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AcceptNewEmail',
  data () {
    return {
      loading: false,
      tryAgainUrl: null,
      errorMessage: null,
      code: null,
      validateErrors: {}
    }
  },
  metaInfo () {
    return {
      title: 'Carregando...'
    }
  },
  computed: {
    status () {
      return this.$route.query.status
    },
    errorCode () {
      return this.$route.query.error_code
    },
    oneTimeToken () {
      return this.$route.query.one_time_token
    },
    emailVerificationRequired () {
      return this.$route.query.email_verification_required
    }
  },
  created () {
    if (this.status === 'error') {
      this.showError(this.errorCode)
    } else if (this.oneTimeToken && !this.emailVerificationRequired) {
      this.auth()
    }
  },
  methods: {
    auth () {
      this.$store.dispatch('authLoginDefinitiveToken', {
        one_time_token: this.oneTimeToken,
        code: this.code
      }).then(res => {
        this.redirectToHome()
      }).catch(err => {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        } else {
          this.errorMessage = err.response.data.message
        }
      })
    },
    showError (errorCode) {
      this.$store.dispatch('authLoginErrorData', {
        error_code: errorCode
      }).then(res => {
        this.tryAgainUrl = res.try_again_url
        this.errorMessage = res.error_message
      })
    },
    redirectToHome () {
      this.$router.push('/')
    },
    tryAgain () {
      if (this.tryAgainUrl) {
        window.location.href = this.tryAgainUrl
      } else {
        this.$router.push('/auth')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/OneTimeToken.vue